import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import * as Sentry from "@sentry/react";

import { DEPLOY_ENV, DEV, RELEASE_HASH, SENTRY_DSN } from "./config";
import { isNetworkLoggingEnabled } from "./utils/network-logging";
import { reportPreSentryInitErrors } from "./utils/pre-sentry-init-errors";

//////////////////////////////////////////////////////////////////////////////
// Apollo                                                                   //
//////////////////////////////////////////////////////////////////////////////

if (DEV) {
  loadDevMessages();
  loadErrorMessages();
}

//////////////////////////////////////////////////////////////////////////////
// Sentry                                                                   //
//////////////////////////////////////////////////////////////////////////////

const BASE_IGNORE_ERRORS = ["mce-visual-caret-hidden"];
const IGNORE_ERRORS = [
  ...BASE_IGNORE_ERRORS,
  // specific network errors
  "TypeError: Failed to fetch (suggestion",
];

Sentry.init({
  dsn: SENTRY_DSN,
  environment: DEPLOY_ENV,
  release: RELEASE_HASH,
  // This sets the sample rate to be 1% on prod.
  // Note: For development is set to be 100%
  replaysSessionSampleRate: DEV ? 1 : 0.01,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 0.8,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.browserTracingIntegration(),
  ],
  // Adjusted for production to 25% to reduce the amount of data sent to Sentry
  tracesSampleRate: DEV ? 1 : 0.25,
  ignoreErrors: isNetworkLoggingEnabled() ? BASE_IGNORE_ERRORS : IGNORE_ERRORS,
});

reportPreSentryInitErrors(isNetworkLoggingEnabled());
